import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ShareExportService } from 'src/app/core/services/share-export.service';
import { FarmDeviceDetailItem } from '../../../models/farm-device.model';
import { DetailService } from '../../../services/detail.service';

@Component({
  selector: 'map-farm-detail',
  templateUrl: './map-farm-detail.component.html',
  styleUrls: ['./map-farm-detail.component.scss'],
})
export class MapFarmDetailComponent implements OnInit {
  @Input() tempFarmAttrId: number;
  @Input() sensorType: string;
  @Input() existAllDevice: boolean = false;
  detailItem: FarmDeviceDetailItem;
  farmCoords;
  constructor(private detailService: DetailService, private translateService: TranslateService,
    private loadingService: LoadingService, private shareExportService: ShareExportService) { }

  ngOnInit() {
    this.getFarmDetail();
  }

  getFarmDetail() {
    this.loadingService.showLoading();
    this.detailService.getDetail(this.sensorType, this.tempFarmAttrId).subscribe(res => {
      this.loadingService.hideLoading();
      if (res.IsSuccess) {
        this.detailItem = res.Data;
        let geoJsonParsed = JSON.parse(this.detailItem.Location);
        this.farmCoords = geoJsonParsed.geometry.coordinates[0][0].reverse().map(t => Math.round(t * 1000) / 1000).join(",")
      }
    }, err => {
      this.loadingService.hideLoading();
    });
  }

  shareLocation() {
    let location = JSON.parse(this.detailItem.Location);
    this.shareExportService.share({
      DialogTitle: this.translateService.instant("detail.field-information"),
      Text: this.detailItem.CityName + "\n" + this.translateService.instant("crops." + this.detailItem.CropName),
      Title: this.detailItem.FarmName,
      Url: "https://maps.google.com/maps?q=" + location.geometry.coordinates[0][0][0] + "," + location.geometry.coordinates[0][0][1] + "&z=17"
    }).subscribe(res => { });
  }


  openMap() {
    let location = JSON.parse(this.detailItem.Location);
    this.shareExportService.GetMapTypes(location.geometry.coordinates[0][0][0], location.geometry.coordinates[0][0][1]);
  }

}
